import React from 'react'
import { Route } from 'react-router-dom'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { IconActivityLog } from '../../../../shared/icon/icon'
import { NoAccess } from '../../../../role/components/no-access'
import { useAuditCapabilities } from '../../../../shared/audit/use-audit-capabilities'
import { RetentionPage } from './retention-page'

// /admin/audit-retention: super admins with the retention capability
// (GET /audit/capabilities); everyone else gets NoAccess, and nothing shows
// while the capabilities load. An impersonated session reads it only.
const Gate = () => {
  const caps = useAuditCapabilities()
  if (!caps.loaded) return null
  if (!caps.retention) return <NoAccess what="audit retention settings" />
  return (
    <BreadcrumbView Icon={IconActivityLog} text="Audit retention">
      <RetentionPage readOnly={Boolean(caps.impersonating)} />
    </BreadcrumbView>
  )
}

export const LayoutAuditRetention = () =>
  <Route path="/admin/audit-retention" exact>
    <Gate />
  </Route>
